import React, { memo } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { number, string, arrayOf, bool } from 'prop-types'

function DesignerModel({
  primaryImage,
  title,
  price,
  finalPrice,
  formats,
  slug,
  id,
  percentage: percentageDiscount = null,
  lazyLoad = false,
}) {
  return (
    <article className="card-3d-model__article">
      <div
        // note: js-track-featured-item is used for tracking purposes
        className="cgt-model-card__image-container card-3d-model__image-container js-track-featured-item"
        data-model-id={id}
      >
        <a className="cgt-model-card__link js-track-click" href={slug}>
          <picture>
            <source srcSet={primaryImage} type="image/webp" {...(lazyLoad ? { loading: 'lazy' } : {})} />
            <img
              className="cgt-model-card__image"
              src={primaryImage}
              alt={title}
              loading={lazyLoad ? 'lazy' : undefined}
            />
          </picture>
        </a>
      </div>
      <div className="card-3d-model__format-tags card-3d-model__format-tags--visible">
        {formats.map((format, index) => (
          <span
            key={index}
            className={classnames(
              'cgt-badge cgt-legacy-text-caption cgt-badge--white',
              'cgt-badge--with-hover cgt-effect-card-border-disabled'
            )}
          >
            <div className="cgt-badge__content">{format}</div>
          </span>
        ))}
      </div>
      <div className="card-3d-model__price card-3d-model__price--visible">
        {!!percentageDiscount && (
          <div className="cgt-tag cgt-legacy-back-color-utility-danger-100 cgt-legacy-color-white-100">
            <span className="cgt-tag__text">-{Math.round(percentageDiscount)}%</span>
          </div>
        )}
        {!!price && (
          <div
            className={classnames(
              'cgt-tag',
              'cgt-legacy-back-color-white-100',
              'cgt-color-undefined',
              'cgt-tag--border',
              'card-3d-model__price-tag'
            )}
          >
            <span className="cgt-tag__text">
              {Number.isInteger(finalPrice) ? `$${finalPrice}` : `$${finalPrice.toFixed(2)}`}
            </span>
          </div>
        )}
      </div>
      <div className="card-3d-model__footer-title">
        <h3 className="card-3d-model__footer-title-content">
          <a href={slug} className="js-track-click" data-attributes='{"id":"4636653","item_index":1}'>
            {title}
          </a>
        </h3>
      </div>
    </article>
  )
}

DesignerModel.propTypes = {
  primaryImage: string.isRequired,
  title: string.isRequired,
  price: number.isRequired,
  finalPrice: number.isRequired,
  formats: arrayOf(string).isRequired,
  slug: string.isRequired,
  id: number.isRequired,
  percentage: number,
  lazyLoad: bool,
}

export default memo(DesignerModel)
